module.exports = __webpack_public_path__ + "img/check-circle-black-icon.06e6ee21.svg";